/**
 * @author sudong.duan
 * Date: 21-12-16
 * desc: axios请求方法
 */

import axios from 'axios'
import router from '@/router';
import { isEmpty } from './common'
import { Message } from 'iview'
//import { removeAccountInfoStorage, removeTokenStorage } from './storage'



let baseUrl = ''
const protocol = window.location.protocol ? window.location.protocol : 'http:'

const host = location.host
// if (process.env.NODE_ENV === 'development') {
// 	baseUrl = `${protocol}//47.92.154.193:8090`
// } else if (process.env.NODE_ENV === 'pre') {
// 	baseUrl = `${protocol}//47.92.154.193:8090`
// } else if (process.env.NODE_ENV === 'production') {
// 	baseUrl = `${protocol}//${host}`
// } else {
// 	baseUrl = `${protocol}//47.92.154.193:8090`
// }


if (process.env.NODE_ENV === 'development') {
	baseUrl = `${protocol}//dev.backend.7nc.top`
} else if (process.env.NODE_ENV === 'pre') {
	baseUrl = `${protocol}//dev.backend.7nc.top`
} else if (process.env.NODE_ENV === 'production') {
	baseUrl = `${protocol}//${host}`
} else {
	baseUrl = `${protocol}//dev.backend.7nc.top`
}

const responseCode = {
	/**
	 * post请求成功
	 */
	postSuccess: 0,
	/**
	 * get请求成功
	 */
	getSuccess: 1
}


//请求前拦截
axios.interceptors.request.use(
	(config) => {
		if (config.url.indexOf('http://') === -1 && config.url.indexOf('https://') === -1) {
			config.url = baseUrl + config.url
		}
		const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
		config.headers['token'] = userInfo.token || ""
		config.headers['userId'] = userInfo.customerId || ""
		if (!config.responseType) {
			config.transformResponse = [(data) => {
				return JSON.parse(data)
			}]
		}


		return config
	},
	(error) => {
		return error
	}
)

//请求返回拦截
axios.interceptors.response.use(
	(response) => {
		try {
			if (response) {
				const result = response
				return result
			}
		} catch (err) {
			//window.$message.error(err)
			return {}
		}
	},
	(error) => {
		if (error.response) {
			return error.response
		}
	}
)

export const requestApi = (params) => {
	return new Promise((resolve, reject) => {
		if (params.method === 'GET') {
			axios.get(params.url, { params: params.data, responseType: params.responseType, headers: params.headers, })
				.then((res) => {
					if (params.responseType) {
						resolve(res)
					} else {
						if (isEmpty(res) || isEmpty(res.data)) {
							Message.error('网络请求失败，请稍后再试')
							return
						}
						if (res.data.Code === responseCode.postSuccess || res.data.result === responseCode.getSuccess) {
							resolve(res.data)
						} else if (res.data.Code === 610) {
							localStorage.removeItem('userInfo')
							Message.error(res.data.Msg)
							router.push('/')
						} else {
							if (!params.hideNote) {
								Message.error(res.data.Msg || res.data.message || '网络请求失败')
							}
							reject(res.data)
						}
					}

				})
		} else if (params.method === 'POST') {
			axios.post(params.url, params.data, { headers: Object.assign({ "Content-Type": "application/json" }, params.headers || {}) })
				.then((res) => {
					if (params.responseType) {
						resolve(res)
					} else {
						if (isEmpty(res) || isEmpty(res.data)) {
							Message.error('网络请求失败，请稍后再试')
							return
						}
						if (res.data.Code === responseCode.postSuccess || res.data.result === responseCode.getSuccess) {
							resolve(res.data)
						} else if (res.data.Code === 610) {
							localStorage.removeItem('userInfo')
							Message.error(res.data.Msg)
							router.push('/')
						} else {
							if (!params.hideNote) {
								Message.error(res.data.Msg || res.data.message || '网络请求失败')
							}
							reject(res.data)
						}
					}
				})
		}
	})
}

 //export { axios }


// WEBPACK FOOTER //
// ./src/utils/axios.js